import { BrowserCodeReader, Code39Reader, DecodeHintType } from '@zxing/library';
window.scanner_loaded = false;
window.addEventListener('load', function () {
    
    let selectedDeviceId;
    let scannerModal = $('#scanner-modal');
    const codeReader = new BrowserCodeReader(new Code39Reader(), 500);

    codeReader.getVideoInputDevices()
        .then((videoInputDevices) => {

            const sourceSelect = document.getElementById('sourceSelect')
            selectedDeviceId = videoInputDevices[0].deviceId
            videoInputDevices.forEach((element) => {
                const sourceOption = document.createElement('option')
                sourceOption.text = element.label
                sourceOption.value = element.deviceId
                sourceSelect.appendChild(sourceOption)
            })
            sourceSelect.onchange = () => {
                selectedDeviceId = sourceSelect.value;
            }

            if(videoInputDevices.length > 1){
                scannerModal.find('.modal-footer').show();
            }
            //scannerModal.find('.modal-footer').show();

            window.scanner_loaded = true;    
        })
        .catch((err) => {
            console.error(err)
        });
    
    scannerModal.on('shown.bs.modal', (e) => {
        codeReader.decodeOnceFromVideoDevice(selectedDeviceId, 'video-input').then((result) => {
            let vin = _.trimStart(result.text, 'I');
            var vinFoundEvent = new Event('VinFoundEvent');
            vinFoundEvent.vin = vin;
            document.dispatchEvent(vinFoundEvent);
            codeReader.reset();
            scannerModal.modal('hide')
        }).catch((err) => {
            codeReader.reset();
            scannerModal.modal('hide')
        });
    });

    scannerModal.on('hidden.bs.modal', (e) => {
        codeReader.reset();
    });

})



// WEBPACK FOOTER //
// ./resources/js/scanner.js